import styled from 'styled-components';

const SectionLeaderboard = styled.section``;

export default SectionLeaderboard;
